import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const ComprehensivePrivacy = () => {
  return (
    <>
      <Helmet>
        <title>Aviso de Privacidad Integral | Centro Médico MEDAM</title>

        <meta
          name="description"
          content="Consulta el Aviso de Privacidad Integral del Centro Médico MEDAM. Conoce cómo recopilamos, utilizamos, protegemos y compartimos tus datos personales, así como la forma de ejercer tus derechos ARCO conforme a la legislación mexicana."
        />

        <meta
          name="keywords"
          content="aviso de privacidad, privacidad, datos personales, derechos ARCO, LFPDPPP, protección de datos, Centro Médico MEDAM, HD Salud Integral, Texcoco, Estado de México"
        />

        <meta name="author" content="Centro Médico MEDAM" />

        <meta name="robots" content="index, follow" />

        <meta name="language" content="es-MX" />

        <meta name="revisit-after" content="30 days" />

        <meta
          property="og:title"
          content="Aviso de Privacidad Integral | Centro Médico MEDAM"
        />

        <meta
          property="og:description"
          content="Infórmate sobre el tratamiento de tus datos personales, finalidades, derechos ARCO, transferencias de información y medidas de protección implementadas por Centro Médico MEDAM."
        />

        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="Centro Médico MEDAM" />

        <meta property="og:locale" content="es_MX" />

        <meta
          property="og:url"
          content="https://centromedicomedam.com/aviso-de-privacidad-integral"
        />

        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <meta property="og:image:alt" content="Centro Médico MEDAM" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Aviso de Privacidad Integral | Centro Médico MEDAM"
        />

        <meta
          name="twitter:description"
          content="Consulta cómo Centro Médico MEDAM protege tus datos personales y conoce tus derechos conforme a la legislación mexicana."
        />

        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        />

        <link
          rel="canonical"
          href="https://centromedicomedam.com/aviso-de-privacidad-integral"
        />
      </Helmet>
      <Grid container width="100%" sx={design.BackGroud}>
        <Grid size={design.Grid1} />
        <Grid container size={design.Grid10} pt={3}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Contacto para médicos"
            sx={design.Titulo}
          >
            Aviso de privacidad integral
          </CustomText>
          <Grid container width="100%" pb={5}>
            <Grid size={design.Grid2} />
            <Grid size={design.Grid8}>
              <CustomText
                variant="subtitle1"
                color="#333333"
                text="Eres medico y quieres"
                sx={design.Description}
              >
                <strong>HD Salud Integral S.A. de C.V.</strong> Domicilio
                fiscal: Fray Pedro de Gante No. 108, Colonia Centro, C.P. 56100,
                Texcoco, Estado de México.
                <br />
                <br />
                HD Salud Integral S.A. de C.V., en su carácter de responsable
                del uso y protección de sus datos personales, y en cumplimiento
                con lo establecido en la Ley Federal de Protección de Datos
                Personales en Posesión de los Particulares (LFPDPPP), le informa
                lo siguiente:
                <br />
                <br />
                <strong>
                  ¿Para qué fines utilizaremos sus datos personales?
                </strong>{" "}
                Los datos personales que recabamos de usted serán utilizados
                para las siguientes finalidades primarias:
                <br />
                <br />
                {Datos.map((text, index) => (
                  <Box key={index} sx={design.Box}>
                    <Box component="span" sx={design.span}>
                      &bull;
                    </Box>
                    {text}
                  </Box>
                ))}
                <br />
                Adicionalmente, podremos utilizar su información personal para
                las siguientes finalidades secundarias, que no son necesarias
                para la prestación del servicio pero nos permiten ofrecer una
                mejor atención:
                <br />
                <br />
                {Atenc.map((text, index) => (
                  <Box key={index} sx={design.Box}>
                    <Box component="span" sx={design.span}>
                      &bull;
                    </Box>
                    {text}
                  </Box>
                ))}
                <br />
                Usted podrá manifestar su negativa al tratamiento de sus datos
                para finalidades secundarias mediante escrito libre o enviando
                un correo electrónico a la dirección de contacto que se señale
                en este aviso.
                <br />
                <br />
                <strong>
                  ¿Con quién compartimos su información personal?
                </strong>{" "}
                Sus datos personales podrán ser compartidos con:
                <br />
                <br />
                {Perso.map((text, index) => (
                  <Box key={index} sx={design.Box}>
                    <Box component="span" sx={design.span}>
                      &bull;
                    </Box>
                    {text}
                  </Box>
                ))}
                <br />
                <strong>¿Cómo puede ejercer sus derechos ARCO?</strong> Usted
                tiene derecho a acceder, rectificar y cancelar sus datos
                personales, así como a oponerse al tratamiento de los mismos o
                revocar el consentimiento que haya otorgado.
                <br />
                <br />
                Para ejercer estos derechos, deberá presentar su solicitud por
                escrito en nuestras instalaciones o al correo electrónico que se
                indique en nuestro sitio web oficial. Su solicitud deberá
                cumplir con los requisitos establecidos en la ley.
                <br />
                <br />
                <strong>Cambios al aviso de privacidad</strong> Nos reservamos
                el derecho de realizar modificaciones o actualizaciones al
                presente aviso en cualquier momento. Cualquier cambio será
                publicado en el sitio web oficial del Centro Médico MEDAM.
                <br />
                <br />
                <strong>Contacto</strong> Para cualquier duda sobre este aviso o
                el tratamiento de su información personal, puede comunicarse
                directamente en nuestras instalaciones ubicadas en el domicilio
                fiscal arriba indicado o a través del formulario de contacto en
                nuestro sitio web.
              </CustomText>
            </Grid>
            <Grid size={design.Grid2} />
          </Grid>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
      <Footer />
    </>
  );
};
export default ComprehensivePrivacy;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    // backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
  },
  Titulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "center",
    paddingTop: 2,
    width: "100%",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "justify",
    width: "100%",
    marginTop: 2,
  },
  Bull: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "justify",
    width: "100%",
  },
  Box: {
    display: "flex",
    alignItems: "flex-start",
    mb: 2,
    paddingLeft: 5,
    paddingRight: 5,
  },
  span: { pr: 1, lineHeight: "1.5" },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid2: { xs: 1, md: 3, xl: 3, lg: 3 },
  Grid8: { xs: 10, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 10, md: 10, xl: 10, lg: 10 },
};

const Datos = [
  "Realizar los estudios clínicos necesarios para el diagnóstico y tratamiento médico.",
  "Integrar y mantener actualizado su historial clínico.",
  "Informar a los profesionales de la salud internos para una atención médica adecuada.",
  "Gestionar y realizar el cobro de los servicios médicos prestados.",
  "Emitir los comprobantes fiscales digitales correspondientes.",
  "Agendar citas y coordinar procedimientos médicos o de laboratorio.",
];
const Atenc = [
  "Propuesta de estudios complementarios.",
  "Integración de bases de datos clínicos con fines estadísticos o de mejora interna.",
  "Fines mercadológicos o publicitarios.",
];

const Perso = [
  "Médicos tratantes o especialistas auxiliares para la continuidad del tratamiento.",
  "Instituciones aseguradoras, cuando el servicio médico sea reclamado vía seguro.",
  "Proveedores de servicios clínicos auxiliares (laboratorio, imagenología, ambulancias) bajo contrato de confidencialidad.",
  "Autoridades sanitarias o administrativas, cuando lo exija la legislación aplicable.",
];
